import LmEntityActions from '@components/ag-grid-helpers/EntityActions'
import AgGridPriceField from '@/components/ag-grid-helpers/AgGridPriceField'
import { priceRenderer } from '@/lib/generic.utils'

export const gridOptions = {
  computed: {
    gridOptions() {
      if (!this.tableData) return
      return {
        rowData: this.tableData.fields,
        columnDefs: this.__getColDefs(),
        frameworkComponents: {
          agGridPriceField: AgGridPriceField
        },
        domLayout: 'normal',
        context: {
          actions: [
            {
              icon: 'trash',
              tooltip: 'Delete',
              onClick: this.delete,
              color: 'faded'
            }
          ]
        }
      }
    }
  },

  methods: {
    __getColDefs() {
      const columnDefs = this.tableData.columns.map(col => {
        const excludedField = col.field === 'name'
        const cellRenderer = excludedField ? params => params.value || 'N/A' : params => priceRenderer(params.value, 0)
        const cellEditor = excludedField ? 'agTextCellEditor' : 'agGridPriceField'

        return {
          headerName: col.value,
          field: col.field,
          cellRenderer,
          editable: true,
          cellEditor,
          ...(!excludedField && {
            cellEditorParams: {
              decimals: '0'
            }
          })
        }
      })

      columnDefs.push({
        headerName: 'Actions',
        cellRendererFramework: LmEntityActions,
        suppressMovable: true,
        headerClass: 'text-center',
        cellStyle: { textAlign: 'center' },
        sortable: false,
        lockVisible: true
      })

      return columnDefs
    }
  }
}
